import React from 'react';
import { Confirm } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { interFontStyle, deleteModalsStyles } from 'src/styles';
import CircleWarning from 'src/assets/CircleWarning';
import { ShsButton } from 'src/components/common';

export const DeleteModal: React.FC<any> = ({ isOpen, onClose, onConfirm, onCancel }) => {
    return (
        <>
            <Confirm
                isOpen={isOpen}
                loading={false}
                title={''}
                onConfirm={close}
                onClose={close}
                sx={deleteModalsStyles}
                content={
                    <>
                        <div className="shs-modal-header">
                            <Box sx={{ textAlign: 'center' }}>
                                <CircleWarning />
                            </Box>
                            <Typography variant="h5" component="h5" mb={2} mt={1} fontWeight="600" align="center">
                                Видалення Дитини
                            </Typography>
                        </div>
                        <div className="shs-modal-body">
                            <Typography component="div" mb={3} align="center" sx={interFontStyle}>
                                Чи впевнені ви що хочете видалити дитину?
                            </Typography>
                            <Typography component="div" mb={4} align="center" sx={interFontStyle}>
                                Після видалення дитини всі дані про неї, розклади та звіти будуть видалені й не
                                підлягатимуть відновленню.
                            </Typography>
                        </div>
                        <div className="shs-modal-footer" style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <ShsButton
                                label="Скасувати видалення"
                                styleType="outline"
                                onClick={onClose}
                                sx={{ flex: '1', marginRight: '1em' }}
                            />
                            <ShsButton
                                label="Видалити дитину"
                                styleType="filled-danger"
                                onClick={onConfirm}
                                sx={{ flex: '1' }}
                            />
                        </div>
                    </>
                }
            />
        </>
    );
};
